module.exports = styles;


//////////////////
// WEBPACK FOOTER
// external "styles"
// module id = 8
// module chunks = 0